import Typography from "@mui/material/Typography";

import ProgressBar from 'app/components/ProgressBar';
import { STATUS } from 'apps/portal/utils/Constants';

const calculateProgress = request => {
  if (request.progress) {
    return request.progress;
  }

  let total = request.total || 0;
  let count = request.count || 0;
  let progress = total > 0 ? Math.floor((count / total) * 100) : 0;

  return {
    count,
    total,
    progress,
    status: request.status,
    phases: []
  }
}

const truncate = (value, maxLength) => {
  if (!value || value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength - 3)}...`;
}

const getActivePhase = progress => {
  if (!progress.phases || progress.phases.length === 0) {
    return null;
  }

  let failedPhase = progress.phases.find(phase => phase.status === 0);
  if (failedPhase) {
    return failedPhase;
  }

  let processingPhase = progress.phases.find(phase => phase.status === 2);
  if (processingPhase) {
    return processingPhase;
  }

  let incompletePhase = progress.phases.find(phase => phase.progress < 100);
  if (incompletePhase) {
    return incompletePhase;
  }

  return progress.phases[progress.phases.length - 1];
}

const QRCodeGeneratorProgressBar = props => {
  const {
    qrCodeRequest,
    onClick
  } = props;

  const progress = calculateProgress(qrCodeRequest);
  const label = `${progress.progress}%`;
  const status = STATUS[progress.status] || 'Unknown';
  const activePhase = getActivePhase(progress);
  const detail = activePhase ?
    `${activePhase.label}: ${activePhase.count} / ${activePhase.total}` :
    `${progress.count} / ${progress.total}`;
  const error = progress.error || (activePhase && activePhase.error);
  const warning = error ?
    `Failed - ${truncate(error, 80)}` :
    `${progress.stale ? 'Possibly stuck' : status} - ${detail}`;

  return (
    <div onClick={onClick} style={{ cursor: 'pointer', minWidth: 180 }} title={error || undefined}>
      <ProgressBar label={label} progress={progress.progress} />
      <Typography
        variant="body2"
        sx={{ color: error ? 'error.main' : progress.stale ? 'warning.main' : 'text.secondary' }}
      >
        {warning}
      </Typography>
    </div>
  );
}

export default QRCodeGeneratorProgressBar;
